export const AGGREGATOR_ID = {
  deliveroo: 'EXT-DELIVEROO',
}
